export default /*@ngInject*/ function () {
    const vm = this;

    vm.selectedMigrationChanged = selectedMigrationChanged;

    function selectedMigrationChanged(migration) {
        vm.selectedMigration = null;
        vm.selectedMigration = migration;
    }
}